import api from '@api/endpoints';
import { USER_REFERRALS as types } from '@store/constants';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';

export const getUserReferrals =
  ( userId, pageNo, pageSize ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: types.GETTING_REFERRALS
      });

      const { data } = await api.user.getReferrals({ userId, pageNo, pageSize });

      dispatch({
        type: types.GET_REFERRALS_SUCCESS,
        payload: data
      });

    } catch (error) {
      dispatch(
        setAlert({
          title: 'Something went wrong while fetching user referrals!',
          status: ALERT_STATUS_TYPE.ERROR
        })
      );
      dispatch({
        type: types.GET_REFERRALS_FAILURE,
        payload: error
      });
    }
  };

export const clearUserReferrals = () =>
    async (dispatch) => {
        dispatch({
            type: types.CLEAR_USER_REFERRALS
        });
    };
